import { createIsomorphicFn } from "@tanstack/react-start";

export const getUmbracoCmsBaseUrlEnv = createIsomorphicFn()
	.server(() => {
		return process.env.UMBRACO_CMS_BASE_URL;
	})
	.client(() => {
		return window.env.UMBRACO_CMS_BASE_URL;
	});

export const getUmbracoCmsDomain = createIsomorphicFn()
	.server(() =>
		process.env.UMBRACO_CMS_BASE_URL?.replace("http://", "").replace(
			"https://",
			"",
		),
	)
	.client(() =>
		window.env.UMBRACO_CMS_BASE_URL?.replace("http://", "").replace(
			"https://",
			"",
		),
	);

// The root document embeds these public values in window.env during SSR.
// Client navigation can reuse them without another server-function request.
export const getPublicEnv = createIsomorphicFn()
	.server(() => ({
		UMBRACO_CMS_BASE_URL: process.env.UMBRACO_CMS_BASE_URL,
	}))
	.client(() => window.env);

export const getSiteOrigin = createIsomorphicFn()
	.server(async () => {
		const { getRequestUrl } = await import("@tanstack/react-start/server");
		return getRequestUrl().origin;
	})
	.client(() => window.location.origin);
